import {Spell} from '../../generated/types';

/** Компоненты сокращённо: «С, Ж, М (веточка омелы)» */
export function toSpellComponent(spell: Spell) {
	const components = [];
	if (spell.components.v) components.push('С');
	if (spell.components.s) components.push('Ж');
	if (spell.components.m) components.push(`М (${spell.components.m.text})`);
	return components.join(', ');
}
